import React, { useEffect } from 'react';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

const RunningPhysiologicalChart = ({ completed }) => {
  useEffect(() => {
    if (!completed) return;

    const root = am5.Root.new("chartdiv-running");
    root.setThemes([am5themes_Animated.new(root)]);

    const chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panX: false,
        panY: false,
        wheelX: "none",
        wheelY: "none",
        layout: root.verticalLayout
      })
    );

    chart.set("cursor", am5xy.XYCursor.new(root, {
      behavior: "none",
      xAxis: null,
      yAxis: null
    }));

    const xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        categoryField: "category",
        renderer: am5xy.AxisRendererX.new(root, {
          minGridDistance: 30
        }),
        tooltip: am5.Tooltip.new(root, {})
      })
    );

    const yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        renderer: am5xy.AxisRendererY.new(root, {})
      })
    );

    const series = chart.series.push(
      am5xy.ColumnSeries.new(root, {
        name: "valor",
        xAxis: xAxis,
        yAxis: yAxis,
        valueYField: "value",
        categoryXField: "category",
        tooltip: am5.Tooltip.new(root, {
          labelText: "{categoryX}: {valueY.formatNumber('#.00')}"
        })
      })
    );

    series.columns.template.setAll({
      tooltipY: 0,
      interactive: true,
      cornerRadiusTL: 6,
      cornerRadiusTR: 6,
      fill: am5.color(0x27aae1),
      stroke: am5.color(0x193255)
    });

    series.columns.template.adapters.add("tooltipText", () => {
      return "{categoryX}: {valueY.formatNumber('#.00')}";
    });

    const data = [
      { category: "FTP", value: parseFloat(completed.ftp) || 0 },
      { category: "TSS", value: parseFloat(completed.tss) || 0 },
      { category: "TEA", value: parseFloat(completed.tea) || 0 },
      { category: "TTE", value: parseFloat(completed.tte) || 0 },
      { category: "VO₂ max", value: parseFloat(completed.vo2max) || 0 }
    ];

    xAxis.data.setAll(data);
    series.data.setAll(data);

    return () => {
      root.dispose();
    };
  }, [completed]);

  return (
    <div style={{ maxWidth: '700px', margin: '0 auto', paddingTop: '20px' }}>
      <div id="chartdiv-running" style={{ width: "100%", height: "400px" }}></div>
    </div>
  );
};

export default RunningPhysiologicalChart;
